module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0056.jpg?v=d181d6f9";